import { render } from "./login-dados-pessoais.vue?vue&type=template&id=d21d33c8"
import script from "./login-dados-pessoais.vue?vue&type=script&lang=js"
export * from "./login-dados-pessoais.vue?vue&type=script&lang=js"

import "./login-dados-pessoais.vue?vue&type=style&index=0&id=d21d33c8&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__